class Utils {

	/*constructor() {
		super();
	}*/

	parseDate(dateInput, timeInput) {
		var 
		dateParts = dateInput.split('-'),
		timeParts = timeInput ? timeInput.split(':') : [0,0,0];

		// new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
		return new Date(
			dateParts[0], dateParts[1]-1, dateParts[2],
			timeParts[0], timeParts[1], timeParts[2]
		); // Note: months are 0-based
	}

	getURLQueryParams() {
		'use strict';

		if (!this.stringParams) {
			var 
			objQueryStringParameters = {},
			tmpPairs;

			if (location.search.length > 1) {
				tmpPairs = location.search.substring(1).split('&');
				for (var i in tmpPairs) {
					var pairsplit = [];
					pairsplit[0] = tmpPairs[i].substring(0, tmpPairs[i].indexOf('='));
					pairsplit[1] = tmpPairs[i].substring(tmpPairs[i].indexOf('=')+1);
					if (pairsplit[0].length > 0) objQueryStringParameters[pairsplit[0]] = window.unescape(pairsplit[1]);
				}
			}


			this.stringParams = objQueryStringParameters;
		}

		return this.stringParams;
	}
}

let utils = new Utils();

export default utils;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_utils/utils.js